module.exports = __webpack_public_path__ + "static/media/requests.2c4b0717.svg";